import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Tab, Tabs } from 'vio-components';
import { useReduxState } from 'vio-libs';

import { OrphanedLayersList, SourcesList } from '../components';
import { IMapFeaturesState } from '../interfaces';
import { requestLayers, requestSources } from '../redux';
import { useAppDispatch } from '../redux/hooks';

const Assets: React.FC = () => {
	// HOOKS
	const location = useLocation();
	const dispatch = useAppDispatch();
	// REDUX STATE
	const {
		layers,
		requestingLayers,
		requestingRemoveLayer,
		requestingRemoveSource,
		requestingSources,
		requestingUpdateTileserver,
		sources
	} = useReduxState<IMapFeaturesState>('mapFeatures');
	// REDUX ACTIONS
	const requestSourcesDispatch = bindActionCreators(requestSources, dispatch);
	const requestLayersDispatch = bindActionCreators(requestLayers, dispatch);
	//VARIABLES
	const { tab = 'sources' } = location.state ? location.state as { tab: string } : {};
	const isLoading = requestingLayers || requestingSources || requestingRemoveLayer || requestingRemoveSource || requestingUpdateTileserver;

	useEffect(() => {
		if (!isLoading) {
			requestSourcesDispatch();
			requestLayersDispatch();
		}
	}, []);

	return (
		<div className='container p-4'>
			<div className='row'>
				<div className='col'>
					<h1>Assets</h1>

					<Tabs defaultActiveKey={ tab } >
						<Tab eventKey='sources' title='Sources'>
							<SourcesList
								isLoading={ isLoading }
								layers={ layers }
								sources={ sources } />
						</Tab>

						<Tab eventKey='layers' title='Unassociated Layers'>
							<OrphanedLayersList
								isLoading={ isLoading }
								layers={ layers }
								sources={ sources } />
						</Tab>
					</Tabs>
				</div>
			</div>
		</div>
	);
};

export default Assets;
